// src/rtkQuery/features/hooks/useVideoService.ts

import {
  useConfirmWatchVideoMutation,
  useGetAllVideosQuery,
  useGetWatchedVideosQuery,
} from "@/rtkQuery/features/services/myVideo/videoApi.slice";
import { handleApiResponse } from "@/rtkQuery/lib/helper";
import { toastService } from "@/utils/toastService";

export const useVideoService = () => {
  const {
    data: videos,
    isLoading: videosIsLoading,
    isError: videosIsError,
    refetch,
  } = useGetAllVideosQuery();

  const {
    data: watchedVideos,
    isLoading: watchedVideosLoading,
    isError: watchedVideosError,
    refetch: refetchWatchedVideos,
  } = useGetWatchedVideosQuery();

  const [confirmWatchVideo, confirmResult] = useConfirmWatchVideoMutation();
  const { isLoading: videosIsConfirming } = confirmResult;

  const confirmVideoWatched = async (videoId: number) => {
    try {
      const result = await confirmWatchVideo(videoId);
      handleApiResponse({
        result,
        customSuccessMessage: "Marked video as watched!",
        customErrorMessage: "Could not mark video as watched.",
      });

      if (result.data?.Result?.toLowerCase() === "success") {
        toastService.success(result.data?.Message || "Marked video as watched!");
        refetchWatchedVideos();
      } else {
        toastService.error(result.data?.Message || "Could not mark video as watched.");
      }
    } catch (error) {
      toastService.error("An unexpected error occurred while marking video as watched.");
    }
  };

  return {
    videosData: videos,
    videosIsLoading,
    videosIsError,
    confirmVideoWatched,
    confirmResult,
    videosIsConfirming,
    refetch,

    watchedVideos,
    watchedVideosLoading,
    watchedVideosError,
    refetchWatchedVideos,
  };
};
